// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_dv-0";
export var fileCarousel = "_dv-2";
export var removeFileButton = "_dv-1";